<template>
  <component :is="layoutComponent" :field="field" :errors="errors">
    <template slot="field">
      <div v-for="offer in items" :key="offer.id">
        <div v-if="!offer.editing" class="media mt-2 mb-2">
          <img
            v-if="offer.image"
            :src="offer.image.url"
            style="width: 100px"
            class="mr-3"
          />
          <div class="media-body">
            <p class="text-lg mt-0 offer_name">{{ offer.title }}</p>
            <div class="offer_subname">{{ offer.pricing }}</div>
            <p class="offer_text">{{ offer.description }}</p>
            <a href class="btn btn-light btn-sm" @click.prevent="edit(offer)"
              >Edit</a
            >
            <a href class="btn btn-danger btn-sm" @click.prevent="remove(offer)"
              >Delete</a
            >
          </div>
        </div>
        <offer-form
          v-if="offer.editing"
          :id="offer.id"
          :company="model"
          @saved="finishSave(offer, true)"
          @cancelled="finishSave(offer)"
        />
      </div>
      <br /><button
        v-show="!creating"
        type="button"
        class="btn btn-primary btn-sm mt-3"
        @click="creating = true"
      >
        {{ $t("Add new offer") }}
      </button>
      <hr />
      <offer-form
        v-if="creating"
        :company="model"
        @saved="finishSave(null, true)"
        @cancelled="finishSave()"
      />
    </template>
  </component>
</template>

<script>
import { FieldMixin } from "stylemix-base";
import InnerItems from "../../../../resources/common/InnerItemsMixin";
import OfferForm from "./offers/Form.vue";

export default {
  name: "FormServicesField",

  components: {
    OfferForm,
  },

  mixins: [FieldMixin, InnerItems],

  data: function () {
    return {
      resourceBase: `companies/${this.model.id}/offers`,
    };
  },
};
</script>
